<!-- Skeleton de chargement -->
@if (isLoading) {
  <div class="w-full md:mx-auto md:max-w-md">
    <div class="lg:mb-12 lg:mt-12 kiosk:mb-16 kiosk:mt-12">
      <h1 class="mb-3 mt-6 hidden text-center font-accent text-5xl font-bold md:block">
        {{ 'payment.title' | translate }}
      </h1>
    </div>
    <div class="border-t md:rounded-md md:border">
      <!-- 5 éléments skeleton de 30px de haut -->
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <div class="border-b border-neutral-200">
          <div class="flex items-center justify-between px-5 py-4.5">
            <div class="flex w-4/6 items-center">
              <div class="h-4 w-4 animate-pulse rounded bg-neutral-300 mr-3"></div>
              <div class="h-4 w-32 animate-pulse rounded bg-neutral-300"></div>
            </div>
            <div class="flex w-2/6 justify-end">
              <div class="h-6 w-16 animate-pulse rounded bg-neutral-300"></div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<!-- Contenu principal -->
@if (!isLoading && availablePaymentMethods) {
  <div class="w-full md:mx-auto md:max-w-md">
    <div class="lg:mb-12 lg:mt-12 kiosk:mb-16 kiosk:mt-12">
      <h1 class="mb-3 mt-6 hidden text-center font-accent text-5xl font-bold md:block">
        {{ 'payment.title' | translate }}
      </h1>
      @if (availablePaymentMethods.length > 1) {
        <h2 class="mb-3 mt-5 px-5 font-accent text-md font-bold md:mt-6 md:text-center">
          {{ 'payment.subtitle' | translate }}
        </h2>
      }
    </div>
    <div class="border-t border-neutral-200 md:rounded-md md:border">
      @for (paymentMethod of availablePaymentMethods; track paymentMethod.handle) {
        <div
          class="border-b border-neutral-200"
          [class.disabled]="
            status.isRetryInProgress && paymentMethod.handle !== selectedPaymentMethod?.handle
          "
        >
          <div class="flex cursor-pointer flex-col px-5 text-neutral-600">
            @if (availablePaymentMethods.length > 1) {
              <div
                class="flex items-center justify-between py-4.5"
                (click)="selectPaymentMethod(paymentMethod)"
              >
                <div class="flex w-4/6 items-center">
                  <span class="pr-1.5 text-xs">
                    <input
                      type="radio"
                      [checked]="paymentMethod.handle === selectedPaymentMethod?.handle"
                      class="form-radio m-2 border-2 border-neutral-400 bg-none p-1.5"
                      [ngClass]="{
                        'p-2.5 bg-primary-600 border-primary-600 m-1 shadow-custom':
                          paymentMethod.handle === selectedPaymentMethod?.handle,
                      }"
                    />
                  </span>
                  @if (paymentMethod.label !== 'payment.on-site') {
                    <span>{{ paymentMethod.label | translate }}</span>
                  }
                </div>
                <div class="flex w-2/6 justify-end">
                  @for (logo of paymentMethod.logos; track $index) {
                    <img
                      alt="logo"
                      [src]="logo"
                      class="ml-2 max-h-6"
                    />
                  }
                </div>
              </div>
            }
            @if (paymentMethod.handle === selectedPaymentMethod?.handle) {
              <div [class.pt-6]="availablePaymentMethods.length === 1">
                <app-component-factory
                  [componentClass]="paymentMethod.panelComponent"
                  [data]="paymentMethod.data"
                ></app-component-factory>
              </div>
            }
          </div>
        </div>
      }
      <div class="hidden md:block">
        @if (error; as paymentErrorMessage) {
          <div class="flex justify-between pt-4 text-center">
            <span class="font-base text-error-600">
              {{ paymentErrorMessage | translate }}
            </span>
          </div>
        }
        <div class="pt-8 text-center">
          <span class="mr-1.5 font-accent text-2xl font-bold">Total</span>
          <div class="md:hidden">
            <app-price-atom
              [format]="true"
              [size]="'MD'"
              [amount]="amount ?? 0"
            ></app-price-atom>
          </div>
          <div class="hidden md:inline-block">
            <app-price-atom
              [format]="true"
              [size]="'2XL'"
              [amount]="amount ?? 0"
            ></app-price-atom>
          </div>
        </div>
        <div class="mb-10 flex flex-col items-center pt-4">
          @if (button.isVisible === true) {
            <app-button-atom
              [icon]="!(status.isInProgress || status.isLoading) ? 'icon-black-lock' : ''"
              [iconUrl]="status.isInProgress || status.isLoading ? 'assets/images/spinner.svg' : ''"
              [size]="'M'"
              [type]="'primary'"
              (click)="triggerPayment()"
              [label]="
                (button.text === 'payment.validate-on-site'
                  ? 'payment.validate-on-site-zero'
                  : button.text
                ) | translate
              "
              [disabled]="!button.isEnabled || status.isInProgress"
            ></app-button-atom>
          }
          @if (hasNoAvailablePaymentMethods) {
            <p class="mt-3 max-w-sm px-4 text-center font-base text-sm text-error-600">
              {{ 'payment.no-payment-method-available' | translate }}
            </p>
          }
        </div>
      </div>
    </div>
  </div>
}

<!-- Skeleton mobile -->
@if (isLoading) {
  <div class="fixed bottom-0 left-0 right-0 z-30 bg-white shadow shadow-top md:hidden">
    <div class="container mx-auto p-4 pt-4.5 align-middle">
      <div class="flex items-center justify-center">
        <div class="h-4 w-16 animate-pulse rounded bg-neutral-300 mr-2"></div>
        <div class="h-4 w-20 animate-pulse rounded bg-neutral-300"></div>
      </div>
      <div class="pt-4.5">
        <div class="h-12 w-full animate-pulse rounded bg-neutral-300"></div>
      </div>
    </div>
  </div>
}

<!-- Contenu mobile -->
@if (!isLoading) {
  <div class="fixed bottom-0 left-0 right-0 z-30 bg-white shadow shadow-top md:hidden">
    <div class="container mx-auto p-4 pt-4.5 align-middle">
      @if (error) {
        <div class="flex justify-between">
          <span class="font-base text-error-600">
            {{ error | translate }}
          </span>
        </div>
      }
      @if (amount) {
        <div class="flex items-center justify-center">
          <span class="mr-1.5 font-accent text-md font-bold">Total</span>
          <app-price-atom
            [format]="true"
            [size]="'MD'"
            [amount]="amount"
          ></app-price-atom>
        </div>
      }
      @if (hasErrorMessages) {
        <div>
          @for (message of errorMessages; track $index) {
            <p class="px-4 pt-4 text-base font-normal text-error-700">
              {{ message }}
            </p>
          }
        </div>
      }
      @if (button.isVisible === true) {
        <div class="pt-4.5">
          <app-button-atom
            [icon]="!(status.isInProgress || status.isLoading) ? '' : ''"
            [iconUrl]="status.isInProgress || status.isLoading ? 'assets/images/spinner.svg' : ''"
            [size]="'L'"
            [type]="'primary'"
            (click)="triggerPayment()"
            [label]="button.text | translate"
            [disabled]="!button.isEnabled || status.isInProgress || hasErrorMessages"
          ></app-button-atom>
        </div>
      }
      @if (hasNoAvailablePaymentMethods) {
        <p class="mt-2 px-1 text-center font-base text-sm text-error-600">
          {{ 'payment.no-payment-method-available' | translate }}
        </p>
      }
    </div>
  </div>
}
